import { Store } from "@ngrx/store";
import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { ModalDirective } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { QueryStates } from "../query.reducer";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "app-graphic-panel",
  templateUrl: "./graphic-panel.component.html",
  styleUrls: ["./graphic-panel.component.scss"],
})
export class GraphicPanelComponent implements OnInit {
  subscriptionProcessStore: Subscription;
  @ViewChild("mdOptionsGrap") mdOptionsGrap: ModalDirective;
  registerGraphicPanel: FormGroup;
  submitted: boolean = false;
  listTipoGrafico = [];
  configQuery = [];
  queryId: string;
  basedOnId: string;
  queryConfigType: string;
  arguments: [];
  selectTypeGrafico: string;
  activeIndex: number = 0;
  objectGraphic: any;
  controls: any;
  vewGraphic: boolean = false;
  message = {
    message: null,
    class: null,
  };
  constructor(
    private store: Store<QueryStates>,
    private formBuilder: FormBuilder
  ) {
    this.subscriptionProcessStore = this.store
      .select("processQueryState")
      .subscribe((stateProcess) => {
        this.processStateManage(stateProcess);
      });
  }

  ngOnInit() {
    this.registerGraphicPanel = this.formBuilder.group({
      selectGrafico: [null, Validators.required],
    });
    this.controls = this.registerGraphicPanel.controls;


    this.listTipoGrafico = [
      { type: "Pie Chart", image: "assets/images/pie-chart2.png" },
      { type: "RadialBar", image: "assets/images/radialbar.png" },
      { type: "PolarArea", image: "assets/images/polar-area.png" },
      { type: "Radar", image: "assets/images/radar.png" },
      { type: "Mixed", image: "assets/images/mixed.png" },
      { type: "Area", image: "assets/images/area.png" },
      { type: "Line", image: "assets/images/line.png" },
      { type: "Column", image: "assets/images/column.png" },
      { type: "Donut", image: "assets/images/donut.png" },
      { type: "Number", image: "assets/images/Number.png" },
    ];
  }

  onCancelModal() {
    this.mdOptionsGrap.hide();
    this.mdOptionsGrap.ngOnInit();
    this.mdOptionsGrap.config;
    this.activeIndex = 0;
    this.selectTypeGrafico = "";
  }

  selectGrafico(e) {
    console.log("Seleccion Tipo Grafico", e.value);
    this.selectTypeGrafico = e.value.type;
  }

  processStateManage(stateProcess) {
    switch (stateProcess.stateProcess) {
      case "config-grafic":
        this.configQuery = stateProcess.options.columns;
        this.queryId = stateProcess.options.queryId;
        this.basedOnId = stateProcess.options.basedOnId;
        this.queryConfigType = stateProcess.options.queryConfigType;
        this.arguments = stateProcess.options.arguments;
      default:
        break;
      case "Vew Panel Graphic":
        this.mdOptionsGrap.show();
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.registerGraphicPanel.invalid) {
      this.message = {
        message: "Todos los campos son obligatorios",
        class: "alert alert-danger mt-2",
      };
      setTimeout(() => {
        this.message = {
          message: null,
          class: null,
        };
      }, 3000);
      return;
    }
    this.activeIndex = 1;
    console.log("configQuery", this.configQuery);
  }

  onVewGraphic(object) {
    const argCopy: any = Object.assign({}, object);
    this.objectGraphic = undefined;
    this.objectGraphic = argCopy;
    console.log(this.objectGraphic, 'una mierda');
    console.log(this.selectTypeGrafico, "tipo de grafico");
    console.log(this.vewGraphic, "boolean");
    this.vewGraphic = false;
    this.vewGraphic = true;
    this.activeIndex = 2;
  }
}
